import type { JSX } from 'react'

import { TopNumber10SC } from './TopNumbers.styled'

export const Top10 = (): JSX.Element => (
  <TopNumber10SC
    width='228'
    height='183'
    viewBox='0 0 228 183'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M161.308 0C184.13 0 200.951 8.3877 211.771 25.1627C222.59 41.7682 228 63.8807 228 91.5C228 119.119 222.59 141.317 211.771 158.092C200.951 174.698 184.13 183 161.308 183C143.972 183 130.101 178.209 119.69 168.628V179.95H0V155.042H50.9698V36.6002L16.7362 52.867H15.7217L9.88986 35.3293V34.3125L58.3238 3.0505H78.357V155.042H108.973C99.4015 138.658 94.6153 117.477 94.6153 91.5C94.6153 63.8807 100.025 41.7682 110.845 25.1627C121.664 8.3877 138.485 0 161.308 0ZM161.308 24.1458C147.445 24.1458 137.725 30.2463 132.146 42.4463C126.567 54.4768 123.777 70.828 123.777 91.5C123.777 112.172 126.567 128.609 132.146 140.809C137.725 152.839 147.445 158.854 161.308 158.854C175.17 158.854 184.891 152.839 190.47 140.809C196.048 128.609 198.838 112.172 198.838 91.5C198.838 70.828 196.048 54.4768 190.47 42.4463C184.891 30.2463 175.17 24.1458 161.308 24.1458Z'
      fill='url(#paint0_linear_5096_100020)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100020'
        x1='-18.7651'
        y1='2.88107'
        x2='145.407'
        y2='244.675'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber10SC>
)
